import navigation from "@/lang/en_AU/navigation";
import generics from "@/lang/en_AU/generics";
import questions from "@/lang/en_AU/questions";
import a11y from "@/lang/en_AU/a11y";
import velt from "@/lang/en_AU/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}